export const BILLING_PERIOD_LABELS = {
  monthly: "Aylık",
  yearly: "Yıllık",
  one_time: "Tek seferlik",
};

export const CURRENCY_SYMBOLS = {
  TRY: "₺",
  USD: "$",
  EUR: "€",
};

export function formatPackagePrice(pkg) {
  if (!pkg) return "";
  const symbol = CURRENCY_SYMBOLS[pkg.currency] || pkg.currency || "";
  const amount = Number(pkg.price ?? 0);
  const formatted = amount.toLocaleString("tr-TR", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const period = BILLING_PERIOD_LABELS[pkg.billing_period] || "";
  if (amount === 0) return "Ücretsiz";
  const suffix = pkg.billing_period === "monthly" ? "/ ay" : pkg.billing_period === "yearly" ? "/ yıl" : "";
  return `${symbol}${formatted}${suffix ? ` ${suffix}` : period ? ` · ${period}` : ""}`;
}
